import React, { useEffect, useState } from "react";
import {
  Modal,
  Calendar,
  Input,
  Button,
  Typography,
  Row,
  Col,
  App,
  DatePicker
} from "antd";
import dayjs from "dayjs";
import "./restrictedHolidayModal.css";
import { dateOnlyConversion } from "../../../../lib/functions";

const { Text } = Typography;

const RestrictedHolidayModal = ({
  visible,
  onClose,
  onAddRestrictedHoliday,
  isDisabled,
}) => {
  const { modal } = App.useApp();
  const [dateTime, setDateTime] = useState(dayjs());
  const [holidayDate, setHolidayDate] = useState(null);
  const [notes, setNotes] = useState("");

  // ⏰ Live clock
  useEffect(() => {
    const timer = setInterval(() => setDateTime(dayjs()), 1000);
    return () => clearInterval(timer);
  }, []);

  // 🧹 Reset on close
  useEffect(() => {
    if (!visible) {
      setHolidayDate(null);
      setNotes("");
    }
  }, [visible]);

  // 🚫 Disable past dates
  const disablePastDates = (current) =>
    current && current < dayjs().startOf("day");

  // 🧠 Handle Save
  const handleSave = () => {
    if (!holidayDate)
      return modal.warning({ title: "Select a Holiday Date", centered: true });
    if (!notes?.trim())
      return modal.warning({ title: "Notes is required", centered: true });    

    // ✅ Pass data to parent for dispatch
    onAddRestrictedHoliday({
      restricted_holiday_date: dateOnlyConversion(
        holidayDate
      ),
      notes,
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      className="restricted-holiday-modal"
    >
      {/* Header */}
      <Row justify="space-between" align="middle" style={{ marginTop: "1rem" }}>
        <Col>
          <Text strong className="attendance-modal-title">
            Restricted Holiday
          </Text>
        </Col>
        <Col>
          <Text className="attendance-modal-time">
            {dateTime.format("DD-MMM-YYYY hh:mm:ss A")}
          </Text>
        </Col>
      </Row>

      {/* Calendar */}
      <div className="attendanceOverview-calendar-container" style={{ marginTop: "2rem" }}>
        <Calendar
          fullscreen={false}
          onSelect={setHolidayDate}
          disabledDate={disablePastDates}
          value={holidayDate}
          data-testid="restricted_holiday_calender"
        />
      </div>

      {/* Notes */}
      {/* <div style={{ marginTop: "1.5rem" }}> */}
          <Row gutter={16} style={{ marginTop: "1.5rem" }}>
                <Col xs={24} sm={12}>
          <label className="form-label">
            Holiday Date <span className="form-span">*</span>
          </label>
          <DatePicker
            style={{ width: "100%" }}
            // disabled={initialData}
            value={holidayDate}
            onChange={(val) => setHolidayDate(val)}
            format="DD-MMM-YYYY"
            data-testid="restricted_holiday_date"
            placeholder="Holiday Date"
          />
        </Col>
                <Col xs={24} sm={12}>
        <label className="form-label">
          Notes <span className="form-span">*</span>
        </label>
        <Input
          placeholder="Notes"
             data-testid="restricted_holiday_notes"
          value={notes}
          onChange={(e) => {
            const val = e.target.value;
            if (val.length <= 50) setNotes(val);
          }}
          onKeyDown={(e) => {
            if (
              notes &&
              notes.toString().length >= 50 &&
              !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                e.key
              )
            ) {
              e.preventDefault();
            }
          }}
        />
        <Text type="secondary" style={{ fontSize: 12 }}>
          {notes.length}/50 characters
        </Text>
        </Col>
           </Row>
      {/* </div> */}

      {/* Buttons */}
      <div className="attendance-buttons">
        <Button onClick={onClose}>Discard</Button>
        <Button
          type="primary"
          disabled={isDisabled || !notes}
          onClick={handleSave}
          testid="restricted_holiday_button"
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default RestrictedHolidayModal;
